import {
  faCaretDown,
  faCaretRight,
  faChevronLeft,
  faChevronRight,
  faDownload,
  faFilter,
  faRetweet,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useEffect, useState } from "react";
import Swal from "sweetalert2";
import * as XLSX from "xlsx-js-style";
import * as FileSaver from "file-saver";
import { Pagination } from "../../../Components/Pagination";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/Loading";

// const data = [
//   {
//     product: "NPK Phú Mỹ\n16-16-8+13S+TE (bao 25 kg)",
//     dongBao: ["40000 Bao\n20 Tấn", 40059, 59, "100.15%"],
//     nhapKho: [40000, 40000, 0, "100.00%"],
//     xuatHang: [["SLING", 8000, "", "", "", "", ""]],
//     tonKho: { value: [0, 0, 0, 0, "100%"], style: "" },
//     congThuc: 0,
//   },
//   {
//     product: "NPK Phú Mỹ\n16-8-16+TE (Bao 25 kg)",
//     dongBao: [20800, 20772, -28, "99.86%"],
//     nhapKho: [20800, 20072, -8, "99.96%"],
//     xuatHang: [
//       ["SLING", 40000, "", "", "", "", ""],
//       ["Băng tải", 5260, "", "", "", "", ""],
//     ],
//     tonKho: { value: [5819, -1, 5914, 95, "101.63%"], style: " " },
//     congThuc: 94,
//   },
//   {
//     product: "NPK Phú Mỹ\n16-8-8+TE (Bao 25 kg L1)",
//     dongBao: [20800, 20065, -15, "99.93%"],
//     nhapKho: [20800, 20069, -11, "99.95%"],
//     xuatHang: [
//       [
//         "SLING",
//         12060,
//         { tongSLCX: 2 },
//         "11982",
//         { tongHeThongGhiNhan: 11 },
//         "-18",
//         "99,85%",
//       ],
//       ["Băng tải", 4160, "4069", "-91", "97,81%"],
//     ],
//     tonKho: { value: [3928, 8, 4018, 90, "102.29%"], style: "" },
//     congThuc: 98,
//   },
// ];

export default function ThongKeSanPham() {
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const { lang, proxy } = useSelector((state) => state);
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState(data);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      if (search) {
        Swal.fire({
          title: "Đang tìm kiếm...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
      }
      try {
        const response = await fetch(proxy() + `/api/stats/Kho/v2`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("_token"),
          },
          body: search ? JSON.stringify(search) : undefined,
        });
        const { ThongKeNM } = await response.json();
        setData(ThongKeNM);
        setFilteredData(ThongKeNM);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        Swal.close();
        setLoading(false);
      }
    };

    let delay;

    if (search) {
      delay = setTimeout(() => {
        fetchData();
      }, 700);
    } else {
      fetchData();
    }

    return () => clearTimeout(delay);
  }, [refresh, search]);

  function getFormattedDateTime() {
    const now = new Date();

    const pad = (n) => (n < 10 ? "0" + n : n);

    const day = pad(now.getDate());
    const month = pad(now.getMonth() + 1);
    const year = now.getFullYear();

    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());

    return `${year}-${month}-${day}_${hours}H${minutes}`;
  }

  const handleExport = (data) => {
    const excelData = buildExportData(data);
    const fileName = `DATA_Thống Kê Sản Phẩm_${getFormattedDateTime()}`;

    exportStyledExcel(excelData, fileName);
  };
  const exportStyledExcel = (data, fileName) => {
    const ws = XLSX.utils.json_to_sheet(data, { skipHeader: true });
    const header1 = [
      "Sản phẩm",
      "Đóng bao",
      // "",
      "",
      "",
      "",
      "Nhập kho",
      // "",
      // "",
      "",
      "",
      "",
      "Xuất hàng",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Tồn kho",
      // "",
      "",
      "",
      "",
      // "Công thức chênh lệch thực tế",
    ];
    const header2 = [
      "",
      // "Đóng Bao Dự Kiến",
      "Hệ Thống Ghi Nhận",
      "Đóng Bao Thực Tế",
      "Chênh Lệch Thực Tế",
      "Tỉ Lệ",

      // "Nhập Kho Dự Kiến",
      "Hệ Thống Ghi Nhận",
      "Nhập Kho Thực Tế",
      "Chênh Lệch Thực Tế",
      "Tỉ Lệ",

      "Chế Độ Xuất",
      "Cần Xuất Dự Kiến",
      "",
      "Hệ Thống Ghi Nhận",
      "",
      "Xuất Thực Tế",
      "",
      "Chênh Lệch Thực Tế",
      "Tỷ Lệ",

      // "Tồn Kho Dự Kiến",
      "Hệ Thống Ghi Nhận",
      "Tồn Kho Thực Tế",
      "Chênh Lệch Thực Tế",
      "Tỷ Lệ",
    ];

    XLSX.utils.sheet_add_aoa(ws, [header1, header2, ...data], { origin: "A1" });
    // XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: "A3" });
    const startRow = 2;

    console.log("mappedData");
    const dataLength = data.length;
    const cols = [
      0, 1, 2, 3, 4, 5, 6, 7, 8,  11, 13, 15, 17, 18, 19, 20, 21, 22, 23, 24,
      25,
    ]; // Các cột cần merge

    const merges = [
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, // Sản phẩm
      { s: { r: 0, c: 1 }, e: { r: 0, c: 4 } }, // Đóng bao
      { s: { r: 0, c: 5 }, e: { r: 0, c: 8 } }, // Nhập kho
      { s: { r: 0, c: 9 }, e: { r: 0, c: 17 } }, // Xuất hàng
      { s: { r: 0, c: 18 }, e: { r: 0, c: 21 } }, // Tồn kho
      // { s: { r: 0, c: 25 }, e: { r: 1, c: 25 } }, // Công thức
      // // { s: { r: 1, c: 10 }, e: { r: 1, c: 11 } },
      { s: { r: 1, c: 10 }, e: { r: 1, c: 11 } }, // Số lượng cần xuất dự kiến gộp 2 cột
      { s: { r: 1, c: 12 }, e: { r: 1, c: 13 } }, // Hệ thống cần xuất thực tế gộp 2 cột
      { s: { r: 1, c: 14 }, e: { r: 1, c: 15 } }, // Hệ thống ghi nhận gộp 2 cột
    ];

    cols.forEach((col) => {
      for (let i = 0; i < dataLength; i += 2) {
        const start = startRow + i;

        const end = Math.min(start + 1, startRow + dataLength - 1);
        merges.push({
          s: { r: start, c: col },
          e: { r: end, c: col },
        });
      }
    });

    ws["!merges"] = merges;
    const headerStyles = [
      { fgColor: { rgb: "FFFFFF" }, bold: true },

      // { fgColor: { rgb: "FFF2CC" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "FFF2CC" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "FFF2CC" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "FFF2CC" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "FFF2CC" }, color: { rgb: "455A64" }, bold: true },

      // { fgColor: { rgb: "DAE8FC" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "DAE8FC" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "DAE8FC" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "DAE8FC" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "DAE8FC" }, color: { rgb: "455A64" }, bold: true },

      { fgColor: { rgb: "D5E8D4" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "D5E8D4" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "D5E8D4" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "D5E8D4" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "D5E8D4" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "D5E8D4" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "D5E8D4" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "D5E8D4" }, color: { rgb: "455A64" }, bold: true },

      // { fgColor: { rgb: "0066CC" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "0066CC" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "0066CC" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "0066CC" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "0066CC" }, color: { rgb: "455A64" }, bold: true },
      { fgColor: { rgb: "0066CC" }, color: { rgb: "455A64" }, bold: true },

      // { fgColor: { rgb: "FFFFFF" }, bold: true },
    ];

    const headerAlignment = {
      horizontal: "center",
      vertical: "center",
    };

    const colNum = XLSX.utils.decode_range(ws["!ref"]).e.c + 1;

    for (let i = 0; i < colNum; ++i) {
      const cellRef = XLSX.utils.encode_cell({ c: i, r: 0 });
      if (ws[cellRef]) {
        ws[cellRef].s = {
          fill: headerStyles[i],
          font: headerStyles[i],
          alignment: headerAlignment,
        };
      }
    }

    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = 1; R <= range.e.r; ++R) {
      for (let C = 0; C <= range.e.c; ++C) {
        const addr = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = ws[addr];
        if (cell && typeof cell.v === "string") {
          if (!cell.s) cell.s = {};
          if (!cell.s.alignment) cell.s.alignment = {};

          cell.s.alignment.wrapText = true;
          cell.s.alignment.horizontal = "center";
          cell.s.alignment.vertical = "center";
        }
      }
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], {
      type: "application/octet-stream",
    });
    FileSaver.saveAs(blob, `${fileName}.xlsx`);
  };
  function getNumberBeforeUnit(value) {
    // if (!value) return "";

    const match = value.split("Bao")?.[0].trim();
    console.log("matchmatch", match);
    return match || "";
  }

  const buildExportData = (data) => {
    const result = [];

    // data.forEach((item) => {
    //   const { TenSP, DongBao, NhapKho, PhanPhoi, ton: TonKho } = item;
    //   result.push([
    //     `${TenSP?.value}\n`,
    //     //DongBao
    //     `${DongBao?.SoLuongDuKien}`,
    //     `${DongBao?.SoLuongHeThongGhiNhan}`,
    //     `${DongBao?.SoLuongThucTe}`,
    //     `${DongBao?.ChenhLech}\n`,
    //     `${DongBao?.TiLe}\n`,

    //     //NhapKho
    //     `${NhapKho?.SoLuongDuKien}`,
    //     `${NhapKho?.SoLuongHeThongGhiNhan}`,
    //     `${NhapKho?.SoLuongThucTe}`,
    //     `${NhapKho?.ChenhLech}\n`,
    //     `${NhapKho?.TiLe}\n`,

    //     //XuatHang
    //     "SLING",
    //     `${PhanPhoi?.SoLuongDuKien?.sling}`,
    //     `${PhanPhoi?.SoLuongDuKien?.tong}`,

    //     `${PhanPhoi?.SoLuongHeThongGhiNhan?.sling}`,
    //     `${PhanPhoi?.SoLuongHeThongGhiNhan?.tong}`,

    //     `${PhanPhoi?.SoLuongThucTe?.sling}`,
    //     `${PhanPhoi?.SoLuongThucTe?.tong}`,

    //     `${PhanPhoi?.ChenhLech?.sling}\n`,
    //     `${PhanPhoi?.TiLe?.sling}\n`,

    //     //Ton
    //     `${TonKho?.SoLuongDuKien}`,
    //     `${TonKho?.SoLuongHeThongGhiNhan}`,
    //     `${TonKho?.SoLuongThucTe}`,
    //     `${TonKho?.ChenhLechThucTe}`,
    //     `${TonKho?.TiLe}\n`,
    //     `${TonKho?.CongThucChenhLechThucTe}`,
    //   ]);

    //   result.push([
    //     "",
    //     "",
    //     "",
    //     "",
    //     "",
    //     "",
    //     "",
    //     "",
    //     "",
    //     "",
    //     "",
    //     "Băng tải",
    //     `${PhanPhoi?.SoLuongThucTe?.bangtai}`,
    //     "",
    //     `${PhanPhoi?.SoLuongHeThongGhiNhan?.bangtai}`,
    //     "",
    //     `${PhanPhoi?.ChenhLech?.bangtai}\n`,
    //     `${PhanPhoi?.TiLe?.bangtai}\n`,
    //   ]);
    // });

    data.forEach((item) => {
      const { TenSP, DongBao, NhapKho, PhanPhoi, ton: TonKho } = item;
      result.push([
        `${TenSP?.value}`,
        // DongBao
        // getNumberBeforeUnit(DongBao?.SoLuongDuKien),
        getNumberBeforeUnit(DongBao?.SoLuongHeThongGhiNhan),
        getNumberBeforeUnit(DongBao?.SoLuongThucTe),
        getNumberBeforeUnit(DongBao?.ChenhLech),
        getNumberBeforeUnit(DongBao?.TiLe),

        // NhapKho
        // getNumberBeforeUnit(NhapKho?.SoLuongDuKien),
        getNumberBeforeUnit(NhapKho?.SoLuongHeThongGhiNhan),
        getNumberBeforeUnit(NhapKho?.SoLuongThucTe),
        getNumberBeforeUnit(NhapKho?.ChenhLech),
        getNumberBeforeUnit(NhapKho?.TiLe),

        // Phân phối - SLING
        "SLING",
        getNumberBeforeUnit(PhanPhoi?.SoLuongDuKien?.sling),
        getNumberBeforeUnit(PhanPhoi?.SoLuongDuKien?.tong),
        getNumberBeforeUnit(PhanPhoi?.SoLuongHeThongGhiNhan?.sling),
        getNumberBeforeUnit(PhanPhoi?.SoLuongHeThongGhiNhan?.tong),
        getNumberBeforeUnit(PhanPhoi?.SoLuongThucTe?.sling),
        getNumberBeforeUnit(PhanPhoi?.SoLuongThucTe?.tong),
        getNumberBeforeUnit(PhanPhoi?.ChenhLech?.sling),
        getNumberBeforeUnit(PhanPhoi?.TiLe?.sling),

        // Ton
        // getNumberBeforeUnit(TonKho?.SoLuongDuKien),
        getNumberBeforeUnit(TonKho?.SoLuongHeThongGhiNhan),
        getNumberBeforeUnit(TonKho?.SoLuongThucTe),
        getNumberBeforeUnit(TonKho?.ChenhLechThucTe),
        getNumberBeforeUnit(TonKho?.TiLe),
        // getNumberBeforeUnit(TonKho?.CongThucChenhLechThucTe),
      ]);

      result.push([
        // "",
        // "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "Băng tải",
        getNumberBeforeUnit(PhanPhoi?.SoLuongThucTe?.bangtai),
        "",
        getNumberBeforeUnit(PhanPhoi?.SoLuongHeThongGhiNhan?.bangtai),
        "",
        getNumberBeforeUnit(PhanPhoi?.ChenhLech?.bangtai),
        getNumberBeforeUnit(PhanPhoi?.TiLe?.bangtai),
      ]);
    });

    return result;
  };

  const render = (item) => {
    if (item && typeof item === "object") {
      return Object.entries(item).map(([key, value]) => (
        <>
          {render(value)}
          <br />
        </>
      ));
    }
    return String(item);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const dataPerPage = 4;
  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData =
    filteredData && filteredData.slice(indexOfFirstData, indexOfLastData);
  const totalPages = filteredData && filteredData.length;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const [collapse, setCollapse] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);

  const [mergedHeaders, setMergedHeaders] = useState([
    {
      label: "Thành phẩm",
      rowSpan: 2,
      class: "sticky-col sanpham-col",
      style: {
        color: "rgb(69, 90, 100)",
        borderBottom: "1px solid #ced4da",
      },
    },
    {
      label: "Đóng Bao",
      alias: "DongBao",
      style: {
        color: "#455a64",
        // backgroundColor: "rgb(0, 162, 232)",
        backgroundColor: "#fff2cc",
        borderRight: "2px solid #ced4da",
        borderLeft: "2px solid #ced4da",
      },
      children: [
        // {
        //   label: "Đóng Bao Dự Kiến",
        //   style: {
        //     borderLeft: "2px solid #ced4da",
        //     borderRight: "1px solid #ced4da",
        //     borderBottom: "1px solid #ced4da",
        //   },
        //   // collapse: true,
        // },
        {
          label: "Hệ Thống Ghi Nhận",
          style: {
            borderLeft: collapse["DongBao"] ? "" : "1px solid #ced4da",
            borderRight: "1px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
          collapse: true,
          default: true,
        },
        {
          label: "Đóng Bao Thực Tế",
          style: {
            borderRight: "1px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
          collapse: true,
          default: true,
        },
        {
          label: "Chênh Lệch",
          style: {
            borderRight: "1px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
        },
        {
          label: "Tỉ Lệ",
          style: {
            borderRight: "2px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
          collapse: true,
          default: true,
        },
      ],
    },
    {
      label: "Nhập Kho",
      alias: "NhapKho",
      style: {
        color: "#455a64",
        // backgroundColor: "#190eb9b8",
        backgroundColor: "#dae8fc",
        borderRight: "2px solid #ced4da",
      },
      children: [
        // {
        //   label: "Nhập Kho Dự Kiến",
        //   style: {
        //     borderRight: "1px solid #ced4da",
        //     borderBottom: "1px solid #ced4da",
        //   },
        //   // collapse: true,
        // },
        {
          label: "Hệ Thống Ghi Nhận",
          style: {
            borderRight: "1px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
          collapse: true,
          default: true,
        },
        {
          label: "Nhập Kho Thực Tế",
          style: {
            borderRight: "1px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
          collapse: true,
          default: true,
        },
        {
          label: "Chênh Lệch",
          style: {
            borderRight: "1px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
        },
        {
          label: "Tỉ Lệ",
          style: {
            borderRight: "2px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
          collapse: true,
          default: true,
        },
      ],
    },
    {
      label: "Xuất Hàng",
      style: {
        color: "#455a64",
        // backgroundColor: "#feb019",
        backgroundColor: "#d5e8d4",
        borderRight: "2px solid #ced4da",
      },
      alias: "PhanPhoi",
      children: [
        {
          label: "Chế Độ",
          style: {
            borderRight: "1px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
          collapse: true,
          default: true,
        },
        {
          label: "Số Lượng Xuất Dự Kiến",
          colSpan: 2,
          style: {
            borderRight: "1px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
          // collapse: true,
        },
        {
          label: "Hệ Thống Ghi Nhận",
          colSpan: 2,
          style: {
            borderRight: "1px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
          collapse: true,
          default: true,
        },
        {
          label: "Số Lượng Xuất Thực Tế",
          colSpan: 2,
          style: {
            borderRight: "1px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
          collapse: true,
          default: true,
        },
        {
          label: "Chênh Lệch Thực Tế",
          style: {
            borderRight: "1px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
        },
        {
          label: "Tỉ lệ",
          style: {
            borderRight: "2px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
          collapse: true,
          default: true,
        },
      ],
      colSpan: 9,
    },
    {
      label: "Tồn kho",
      alias: "TonKho",
      style: {
        color: "white",
        // backgroundColor: "#ed1c24cc",
        borderRight: "2px solid #ced4da",
        // backgroundColor: "rgb(19, 160, 35)",
        backgroundColor: "#0066cc",
      },
      children: [
        // {
        //   label: "Tồn Kho Dự kiến",
        //   class: "sticky-col ton4-col",
        //   style: {
        //     borderRight: "1px solid #ced4da",
        //     borderBottom: "1px solid #ced4da",
        //   },
        // },
        //   {
        //     label: "Chênh lệch tổng nhập - xuất so với thực tế",
        //   },
        {
          label: "Hệ Thống Ghi Nhận",
          class: "sticky-col ton3-col",
          style: {
            borderRight: "1px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
          collapse: true,
          default: true,
        },
        {
          label: "Tồn Kho Thực Tế",
          class: "sticky-col ton4-col",
          style: {
            borderRight: "1px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
          collapse: true,
          default: true,
        },
        {
          label: "Chênh Lệch Thực Tế",
          class: "sticky-col ton2-col",
          style: {
            borderRight: "1px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
        },
        {
          label: "Tỉ lệ",
          class: "sticky-col ton1-col",
          style: {
            borderRight: "2px solid #ced4da",
            borderBottom: "1px solid #ced4da",
          },
          collapse: true,
          default: true,
        },
      ],
      class: "sticky-col ton1-col",
    },
    // {
    //   label: "Công thức\nchênh lệch\nthực tế",
    //   rowSpan: 2,
    //   style: {
    //     borderBottom: "1px solid #ced4da",
    //   },
    // },
  ]);

  return (
    <>
      <div className="container-fluid">
        <div className="row" style={{ margin: "5px -15px" }}>
          <div className="col-md-12">
            <div className="white_shd full">
              <div className="tabbar padding_infor_info_p-d-5">
                <div>
                  <div className="d-flex align-items-center page-title position-relative mb-0">
                    <span
                      style={{
                        fontSize: "18px",
                        color: "rgb(68, 161, 161)",
                      }}
                    >
                      THỐNG KÊ SẢN PHẨM
                    </span>
                    <div className="ml-auto d-flex align-items-center">
                      <FontAwesomeIcon
                        icon={faRetweet}
                        className="icon-add mr-2 pointer"
                        fontSize={2}
                        style={{
                          color: "rgb(224, 118, 42)",
                        }}
                        onClick={() => {
                          setRefresh((prev) => prev + 1);
                          //   setSearch();
                          Swal.fire({
                            title: "Đang tải lại dữ liệu...",
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            didOpen: () => {
                              Swal.showLoading();
                            },
                          });
                        }}
                      />
                      <FontAwesomeIcon
                        icon={faDownload}
                        onClick={() => handleExport(data)}
                        className="icon-add mr-2 pointer"
                        fontSize={2}
                        style={{
                          color: "#269c1b",
                        }}
                      />
                    </div>
                  </div>
                  <hr
                    style={{
                      border: "1px solid rgb(221, 221, 221)",
                      margin: "0px -11px 5px",
                    }}
                  />
                  <div className="table-display d-flex">
                    <div className="table-responsive table-custom design-table _table-custom">
                      <table bordered className="align-center">
                        {/* <colgroup>
                          <col />
                          <col span="4" class="DongBao" />
                        </colgroup> */}

                        <thead>
                          <tr>
                            {mergedHeaders.map((head, idx) => {
                              const child = head?.children?.filter(
                                (item) => item.collapse || item.default
                              );
                              return head.children ? (
                                <th
                                  key={idx}
                                  className="pointer"
                                  colSpan={
                                    !collapse["PhanPhoi"]
                                      ? head.alias === "PhanPhoi"
                                        ? child.length + 2
                                        : child.length
                                      : head?.colSpan || child.length
                                  }
                                  style={{
                                    whiteSpace: head.label.includes("\n")
                                      ? "pre"
                                      : "normal",
                                    fontWeight: "bold",
                                    textTransform: "uppercase",
                                    ...head.style,
                                  }}
                                  //   className={head.class || ""}
                                  onClick={() => {
                                    setCollapse((prev) => {
                                      setMergedHeaders((prev) => {
                                        const newPrev = [...prev];
                                        newPrev[idx].children.forEach((sub) => {
                                          sub.collapse = !sub.collapse;
                                        });

                                        return newPrev;
                                      });

                                      return {
                                        ...prev,
                                        [head.alias]: !prev[head.alias],
                                      };
                                    });
                                  }}
                                >
                                  <div className="d-flex justify-content-between">
                                    <span>{head.label}</span>
                                    {!collapse[head.alias] ? (
                                      <span>
                                        <FontAwesomeIcon
                                          fontSize={16}
                                          icon={faChevronLeft}
                                        />
                                        <FontAwesomeIcon
                                          fontSize={16}
                                          icon={faChevronRight}
                                        />
                                      </span>
                                    ) : (
                                      <span>
                                        <FontAwesomeIcon
                                          fontSize={16}
                                          icon={faChevronRight}
                                        />
                                        <FontAwesomeIcon
                                          className="ml-1"
                                          fontSize={16}
                                          icon={faChevronLeft}
                                        />
                                      </span>
                                    )}
                                  </div>
                                </th>
                              ) : (
                                <>
                                  <th
                                    key={idx}
                                    rowSpan={head.rowSpan || 1}
                                    style={{
                                      whiteSpace: head.label.includes("\n")
                                        ? "pre"
                                        : "normal",
                                      fontWeight: "bold",
                                      textTransform: "uppercase",
                                      ...head.style,
                                    }}
                                    className={`${head.class || ""}`}
                                  >
                                    {head.label}
                                    {/* <FontAwesomeIcon
                                      icon={faCaretDown}
                                      onClick={() => {
                                        setOpenFilter({
                                          ...openFilter,
                                          [idx]: !openFilter[idx],
                                        });
                                      }}
                                    />
                                    {openFilter[idx] && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          // right: 0,
                                          backgroundColor: "red",
                                        }}
                                      >
                                        a
                                      </div>
                                    )} */}
                                  </th>
                                </>
                              );
                            })}
                          </tr>
                          <tr>
                            {mergedHeaders
                              .filter((head) => head.children)
                              .flatMap((head) =>
                                head?.children?.map((sub, i) =>
                                  sub?.collapse || sub?.default ? (
                                    <th
                                      key={`${head.label}-${i}`}
                                      colSpan={sub?.colSpan}
                                      // className={sub.class}
                                      style={{
                                        whiteSpace: sub.label.includes("\n")
                                          ? "pre"
                                          : "normal",
                                        fontWeight: "bold",
                                        //   whiteSpace: "nowrap",
                                        ...sub.style,
                                      }}
                                    >
                                      {sub.label}
                                    </th>
                                  ) : null
                                )
                              )}
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td
                              style={{
                                width: "300px",
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                              }}
                              // colSpan={50}
                            >
                              <input
                                type="text"
                                className="form-control"
                                onChange={(e) => {
                                  const searchValue = e.target.value.trim();
                                  // .toLowerCase()
                                  setSearch((prev) => ({
                                    ...prev,
                                    MaSP: searchValue,
                                    TenSP: searchValue,
                                  }));
                                  // if (searchValue) {
                                  // const filtered = currentData.filter(
                                  //   (item) => {
                                  //     return (
                                  //       item?.TenSP?.value
                                  //         ?.toLowerCase()
                                  //         .includes(searchValue) ||
                                  //       item?.MaSP?.value
                                  //         ?.toLowerCase()
                                  //         .includes(searchValue)
                                  //     );
                                  //   }
                                  // );
                                  // setFilteredData(filtered);
                                  // }
                                  // else {
                                  //   setFilteredData(data);
                                  // }
                                }}
                              />
                            </td>
                          </tr>

                          {currentData && currentData.length > 0 ? (
                            currentData.map((item, i) => {
                              const {
                                TenSP,
                                MaSP,
                                DongBao,
                                NhapKho,
                                PhanPhoi,
                                ton: TonKho,
                              } = item;
                              return (
                                <Fragment key={i}>
                                  <tr>
                                    <td
                                      className={`sticky-col sanpham-col text-left ${
                                        i === currentData.length - 1
                                          ? "last-td"
                                          : ""
                                      }`}
                                      style={{
                                        width: "300px",
                                        whiteSpace: "normal",
                                        wordWrap: "break-word",
                                      }}
                                      rowSpan={2}
                                    >
                                      {MaSP?.value}
                                      <br />
                                      {TenSP?.value}
                                    </td>

                                    {/* DongBao */}
                                    {/* {collapse["DongBao"] && (
                                      <td
                                        className="DongBao"
                                        rowSpan={2}
                                        style={{
                                          borderLeft: "2px solid #ced4da",
                                          // color: "rgb(0, 162, 232)",
                                        }}
                                      >
                                        {render(DongBao?.SoLuongDuKien)}
                                      </td>
                                    )} */}
                                    <td
                                      className="DongBao"
                                      rowSpan={2}
                                      style={{
                                        color: "rgb(19, 160, 35)",
                                      }}
                                    >
                                      {render(DongBao?.SoLuongHeThongGhiNhan)}
                                    </td>

                                    <>
                                      <td
                                        className="DongBao"
                                        rowSpan={2}
                                        style={{
                                          color: "rgb(0, 162, 232)",
                                        }}
                                      >
                                        {render(DongBao?.SoLuongThucTe)}
                                      </td>
                                      {collapse["DongBao"] && (
                                        <td
                                          className="DongBao"
                                          rowSpan={2}
                                          style={{
                                            // color: "rgb(237, 28, 36)",
                                            color: "rgb(255, 146, 3)",
                                          }}
                                        >
                                          {render(DongBao?.ChenhLech)}
                                        </td>
                                      )}
                                      <td
                                        className="DongBao"
                                        rowSpan={2}
                                        style={{
                                          borderRight: "2px solid #ced4da",
                                          // color: "rgb(25, 14, 185)",
                                          color: "rgb(237, 28, 36)",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {render(DongBao?.TiLe)}
                                      </td>
                                    </>

                                    {/* NhapKho */}
                                    {/* {collapse["NhapKho"] && (
                                      <td
                                        rowSpan={2}
                                        style={
                                          {
                                            // color: "rgb(0, 162, 232)",
                                          }
                                        }
                                      >
                                        {render(NhapKho?.SoLuongDuKien)}
                                      </td>
                                    )} */}
                                    <td
                                      rowSpan={2}
                                      style={{
                                        color: "rgb(19, 160, 35)",
                                      }}
                                    >
                                      {render(NhapKho?.SoLuongHeThongGhiNhan)}
                                    </td>
                                    <>
                                      <td
                                        rowSpan={2}
                                        style={{
                                          color: "rgb(0, 162, 232)",
                                        }}
                                      >
                                        {render(NhapKho?.SoLuongThucTe)}
                                      </td>
                                      {collapse["NhapKho"] && (
                                        <td
                                          rowSpan={2}
                                          style={{
                                            // color: "rgb(237, 28, 36)",
                                            color: "rgb(255, 146, 3)",
                                          }}
                                        >
                                          {render(NhapKho?.ChenhLech)}
                                        </td>
                                      )}
                                      <td
                                        rowSpan={2}
                                        style={{
                                          borderRight: "2px solid #ced4da",
                                          // color: "rgb(25, 14, 185)",
                                          color: "rgb(237, 28, 36)",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {render(NhapKho?.TiLe)}
                                      </td>
                                    </>

                                    {/* Phân phối SLING */}
                                    <td>SLING</td>
                                    {collapse["PhanPhoi"] && (
                                      <>
                                        <td
                                          style={
                                            {
                                              // color: "rgb(0, 162, 232)",
                                            }
                                          }
                                        >
                                          {render(
                                            PhanPhoi?.SoLuongDuKien?.sling
                                          )}
                                        </td>
                                        <td
                                          rowSpan={2}
                                          // className="font-weight-bold"
                                        >
                                          {render(
                                            PhanPhoi?.SoLuongDuKien?.tong
                                          )}
                                        </td>
                                      </>
                                    )}
                                    <td
                                      style={{
                                        color: "rgb(19, 160, 35)",
                                      }}
                                    >
                                      {render(
                                        PhanPhoi?.SoLuongHeThongGhiNhan?.sling
                                      )}
                                    </td>
                                    <td
                                      rowSpan={2}
                                      // className="font-weight-bold"
                                      style={
                                        {
                                          // color: "rgb(19, 160, 35)",
                                        }
                                      }
                                    >
                                      {render(
                                        PhanPhoi?.SoLuongHeThongGhiNhan?.tong
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        color: "rgb(0, 162, 232)",
                                      }}
                                    >
                                      {render(PhanPhoi?.SoLuongThucTe?.sling)}
                                    </td>
                                    <td
                                      rowSpan={2}
                                      // className="font-weight-bold"
                                      style={
                                        {
                                          // color: "rgb(0, 162, 232)",
                                        }
                                      }
                                    >
                                      {render(PhanPhoi?.SoLuongThucTe?.tong)}
                                    </td>
                                    {collapse["PhanPhoi"] && (
                                      <td
                                        style={{
                                          // color: "rgb(237, 28, 36)",
                                          color: "rgb(255, 146, 3)",
                                        }}
                                      >
                                        {render(PhanPhoi?.ChenhLech?.sling)}
                                      </td>
                                    )}
                                    <td
                                      style={{
                                        borderRight: "2px solid #ced4da",
                                        // color: "rgb(25, 14, 185)",
                                        color: "rgb(237, 28, 36)",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {render(PhanPhoi?.TiLe?.sling)}
                                    </td>

                                    {/* Tồn Kho */}
                                    {/* {collapse["TonKho"] && (
                                      <td
                                        rowSpan={2}
                                        // className="sticky-col ton4-col"
                                        style={
                                          {
                                            // color: "rgb(0, 162, 232)",
                                          }
                                        }
                                      >
                                        {render(TonKho?.SoLuongDuKien)}
                                      </td>
                                    )} */}
                                    <>
                                      <td
                                        rowSpan={2}
                                        style={{
                                          color: "rgb(19, 160, 35)",
                                        }}
                                        // className="sticky-col ton3-col"
                                      >
                                        {render(TonKho?.SoLuongHeThongGhiNhan)}
                                      </td>
                                      <td
                                        rowSpan={2}
                                        // className="sticky-col ton4-col"
                                        style={{
                                          color: "rgb(0, 162, 232)",
                                        }}
                                      >
                                        {render(TonKho?.SoLuongThucTe)}
                                      </td>
                                      {collapse["TonKho"] && (
                                        <td
                                          rowSpan={2}
                                          style={{
                                            // color: "rgb(237, 28, 36)",
                                            color: "rgb(255, 146, 3)",
                                          }}
                                          // className="sticky-col ton2-col"
                                        >
                                          {render(TonKho?.ChenhLechThucTe)}
                                        </td>
                                      )}
                                      <td
                                        rowSpan={2}
                                        // className="sticky-col ton1-col"
                                        style={{
                                          borderRight: "2px solid #ced4da",
                                          // color: "rgb(25, 14, 185)",
                                          color: "rgb(237, 28, 36)",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {render(TonKho?.TiLe)}
                                      </td>
                                    </>

                                    {/* <td rowSpan={2}>
                                      {render(TonKho?.CongThucChenhLechThucTe)}
                                    </td> */}
                                  </tr>

                                  <tr>
                                    <td>Băng Tải</td>
                                    {collapse["PhanPhoi"] && (
                                      <td
                                        style={
                                          {
                                            // color: "rgb(0, 162, 232)",
                                          }
                                        }
                                      >
                                        {render(
                                          PhanPhoi?.SoLuongDuKien?.bangtai
                                        )}
                                      </td>
                                    )}
                                    <td
                                      style={{
                                        color: "rgb(19, 160, 35)",
                                      }}
                                    >
                                      {render(
                                        PhanPhoi?.SoLuongHeThongGhiNhan?.bangtai
                                      )}
                                    </td>

                                    <td
                                      style={{
                                        color: "rgb(0, 162, 232)",
                                      }}
                                    >
                                      {render(PhanPhoi?.SoLuongThucTe?.bangtai)}
                                    </td>

                                    {collapse["PhanPhoi"] && (
                                      <td
                                        style={{
                                          // color: "rgb(237, 28, 36)",
                                          color: "rgb(255, 146, 3)",
                                        }}
                                      >
                                        {render(PhanPhoi?.ChenhLech?.bangtai)}
                                      </td>
                                    )}
                                    <td
                                      style={{
                                        borderRight: "2px solid #ced4da",
                                        // color: "rgb(25, 14, 185)",
                                        color: "rgb(237, 28, 36)",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {render(PhanPhoi?.TiLe?.bangtai)}
                                    </td>
                                  </tr>
                                </Fragment>
                              );
                            })
                          ) : loading ? (
                            <tr>
                              <td colSpan={50} className="align-center">
                                <img
                                  width={35}
                                  className="mb-1"
                                  src="/images/icon/load.gif"
                                  alt="Loading..."
                                />
                              </td>
                            </tr>
                          ) : (
                            <tr>
                              <td colSpan={50} className="align-center">
                                {lang["not found"]}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {currentData && currentData.length > 0 && (
                      <Pagination
                        total={totalPages}
                        itemsPerPage={dataPerPage}
                        currentPage={currentPage}
                        paginate={paginate}
                        lang={lang}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
